import { Navigate, Outlet, useLocation } from "react-router-dom";

const routeRoles = {
  "/leads": ["admin", "lead_manager"],
  "/": ["admin"],
  "/": ["admin"],
  "/add-book": ["admin"],
  "/books-list": ["admin"],
  "/add-mentor": ["admin"],
  "/mentor-list": ["admin"],
  "/users-list": ["admin"],
  "/add-events": ["admin"],
  "/events-list": ["admin"],
  "/add-certificate": ["admin"],
  "/certificates-list": ["admin"],
  "/add-templates": ["admin"],
  "/templatess-list": ["admin"],
  "/frontend-logs": ["admin"],
  "/visiter-logs": ["admin"],
  "/activity-logs": ["admin"],
  "/approve-recruiter": ["admin"],
  "/lead-list": ["admin", "lead_manager"],
  "/lead-view/:id": ["admin", "lead_manager"],
  "/ambassador": ["admin", "lead_manager"],
  "/ambassador/:id": ["admin", "lead_manager"],
  "/price-query": ["admin", "lead_manager"],
  "/price-query/:id": ["admin", "lead_manager"],
};

const PrivateRoutes = () => {
  const token = localStorage.getItem("adminToken");
  const role = localStorage.getItem("role")?.toLowerCase();
  const location = useLocation();

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  const allowedRoles = routeRoles[location.pathname];

  if (allowedRoles && !allowedRoles.includes(role)) {
    return <Navigate to="/leads" replace />;
  }

  return <Outlet />;
};

export default PrivateRoutes;
